import { Divider } from "../styles";

const DropdownDivider = () => {
  return <Divider />;
};

export default DropdownDivider;